<template>
  <RevCard
    class="!bg-static-default-mid w-4/5 max-w-fit self-end whitespace-pre-line px-16 py-12 shadow-none md:w-3/5 !rounded-br-sm"
  >
    <span class="sr-only">
      {{ i18n(translations.emittedFromMe) }}
    </span>
    <slot />
  </RevCard>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'

import translations from '../ShoppingAssistant.translations'

const i18n = useI18n()
</script>
